import { makeStyles } from '@material-ui/core/styles';

import StylesForm from '../StylesForm';

const useStyles = makeStyles((theme) => ({
  drawer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'clip',
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
}));

export default function StylesDrawer() {
  const classes = useStyles();

  return (
    <div className={classes.drawer}>
      <div className={classes.content}>
        <StylesForm />
      </div>
    </div>
  );
}
